/** Clear account data without deleting or temporarily hiding persistent values. */
export function clearAccountStorage(storage: Storage, persistentPrefixes: readonly string[] = []): void {
	const prefixes: readonly string[] = persistentPrefixes.filter((prefix: string) => prefix.length > 0);
	const accountKeys: string[] = [];
	for (let index: number = 0; index < storage.length; index++) {
		const key: string | null = storage.key(index);
		if (key !== null && !prefixes.some((prefix: string) => key.startsWith(prefix))) accountKeys.push(key);
	}
	for (const key of accountKeys) storage.removeItem(key);
}
